const ErrorPage = () => {
  return (
    <div>
      404 PAGE NOT FOUND
    </div>
  )
}
export default ErrorPage